export default {
    PHONE :  /^1(3|4|5|6|7|8|9)\d{9}$/,                  //电话号码
    ZJ:  /^0\d{2,3}-?\d{7,8}$/,         // 座机
    IDCARD: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,           //身份证
    PASSWOED: /(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,35}/,           // 8-12位数字+字母组合
    NAME: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,           //数字+字母+汉字组合
    NUMBER: /^\d{11}$/,          //11位数字
    VALUE: /^[a-zA-Z\d]+$/,         // 字母或数字
    ZZS:  /^[A-Za-z0-9\u4e00-\u9fa5]+$/gi,         // 中文或字母或数字
    integer: /^[0-9]+$/,  // 正整数
    roomNum:/^[0-99]+$/,
    money:/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
}

